import { logAPI } from "./andyliticsApi";
import * as tools from "../helpers/Tools";

const engagementBffApiBaseUrl = !!window ? window.serverData.data.engagementBffApiBaseUrl : '';
const azureFunctionsKey = !!window ? window.serverData.data.engagementBffFunctionsKey : '';

export const getPatientSchedulingPermissions = (token, payload) => {
    const url = tools.buildUrl(engagementBffApiBaseUrl, '/v1/caregap/scheduling/parameters');
    const params = {
        method: "POST",
        body: JSON.stringify(payload),
        headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
            "Authorization": `bearer ${token}`,
            "x-functions-key": azureFunctionsKey,
        },
    };
    var start = new Date();

    return fetch(url, params).then(response => {
        if (response.status >= 200 && response.status < 300) {
            logAPI("MBHWeb.Api.EngagementBFF.CareGapsScheduling.Success", start, url);
            return Promise.resolve(response.json());
        } else {
            return Promise.reject(response);
        }
    }).catch(err => { logAPI("MBHWeb.Api.EngagementBFF.CareGapsScheduling.Failure", start, url, err); return Promise.reject(err); });
};
